import React from "react";

export const normalizeText = (text) => {
  if (!text) return "";
  return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

export const highlightText = (text, searchTerm) => {
  if (!text || !searchTerm || searchTerm.trim() === "") {
    return text;
  }

  try {
    const normalizedSearchTerm = normalizeText(searchTerm.toLowerCase());

    const escapedSearchTerm = normalizedSearchTerm.replace(
      /[.,*+?^${}()|[\]\\]/g,
      "\\$&"
    );

    const pattern = new RegExp(`(${escapedSearchTerm})`, "i");

    const parts = [];
    let remainingText = text;

    while (remainingText) {
      const normalizedRemaining = normalizeText(remainingText.toLowerCase());

      const match = normalizedRemaining.match(pattern);

      if (!match) {
        parts.push({
          text: remainingText,
          isMatch: false,
        });
        break;
      }

      const matchStartIndex = match.index;
      const matchLength = match[0].length;

      const beforeMatch = remainingText.substring(0, matchStartIndex);
      const originalMatch = remainingText.substring(
        matchStartIndex,
        matchStartIndex + matchLength
      );

      if (beforeMatch) {
        parts.push({
          text: beforeMatch,
          isMatch: false,
        });
      }

      parts.push({
        text: originalMatch,
        isMatch: true,
      });

      remainingText = remainingText.substring(matchStartIndex + matchLength);
    }

    return parts.map((part, index) => {
      if (part.isMatch) {
        return (
          <span
            key={index}
            className="highlight-text"
            style={{ backgroundColor: "#dbdbdb", fontWeight: "bold" }}
          >
            {part.text}
          </span>
        );
      }
      return part.text;
    });
  } catch (error) {
    console.error("Error al resaltar texto:", error);
    return text;
  }
};
